import { useState, useEffect } from "react";
import { AlertTriangle, X, CheckCircle, Loader } from "lucide-react";

const MAKINELER = [
  { id: 1, ad: "Boya Hattı #1" },
  { id: 2, ad: "Boya Hattı #2" },
  { id: 3, ad: "Alkali Hat #1" },
  { id: 4, ad: "Alkali Hat #2" },
  { id: 5, ad: "Tandem Hat #1" },
  { id: 6, ad: "Tandem Hat #2" },
];

const API = "https://tez.ulushasturk.com/api.php";

export default function ArizaTestPaneli({ onArizaChange }) {
  const [open, setOpen] = useState(false);
  const [seciliMakine, setSeciliMakine] = useState("");
  const [durum, setDurum] = useState(null);
  const [mesaj, setMesaj] = useState("");
  const [sonuc, setSonuc] = useState(null);
  const [kapaniyor, setKapaniyor] = useState(false);
  const [aktifTestler, setAktifTestler] = useState([]);

  useEffect(() => {
    const kontrol = async () => {
      const bulunanlar = [];
      for (const m of MAKINELER) {
        try {
          const res = await fetch(
            `${API}?action=machine_test_status&machine_id=${m.id}`,
          );
          const data = await res.json();
          if (data.test_mode) bulunanlar.push({ ...m, ...data });
        } catch {}
      }
      setAktifTestler(bulunanlar);
    };
    kontrol();
    const interval = setInterval(kontrol, 5000);
    return () => clearInterval(interval);
  }, []);

  const tetikle = async () => {
    if (!seciliMakine) return;
    setDurum("loading");
    setMesaj("");
    setSonuc(null);
    try {
      const res = await fetch(
        `${API}?action=trigger_failure&machine_id=${seciliMakine}`,
      );
      const data = await res.json();
      if (data.success) {
        setDurum("success");
        setSonuc(data);
        setMesaj(data.message);
        onArizaChange?.();
      } else {
        setDurum("error");
        setMesaj(data.message || "Hata oluştu");
      }
    } catch (e) {
      setDurum("error");
      setMesaj("Bağlantı hatası: " + e.message);
    }
  };

  const kapat = async (machineId) => {
    setKapaniyor(true);
    try {
      const res = await fetch(
        `${API}?action=close_failure&machine_id=${machineId}&note=Demo+testi+tamamlandi`,
      );
      const data = await res.json();
      if (data.success) {
        setAktifTestler((prev) => prev.filter((m) => m.id !== machineId));
        setDurum(null);
        setSonuc(null);
        setMesaj("");
        onArizaChange?.();
      }
    } catch (e) {
      alert("Kapatma hatası: " + e.message);
    } finally {
      setKapaniyor(false);
    }
  };

  return (
    <div className="mb-6">
      {/* Aktif Arıza Bannerleri */}
      {aktifTestler.map((m) => (
        <div
          key={m.id}
          className="mb-2 flex items-center justify-between gap-3 px-4 py-3 rounded-xl border border-red-500/60 bg-red-950/40"
        >
          <div className="flex items-center gap-3">
            <span className="w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse shrink-0" />
            <div>
              <p className="text-red-300 text-sm font-bold">
                ⚠️ {m.ad} — KRİTİK ARIZA AKTİF
              </p>
              <p className="text-slate-400 text-xs mt-0.5">
                İş Emri #{m.work_order_id} açık · Atanan:{" "}
                {m.assigned_to || "Atanmadı"} · Cron durduruldu
              </p>
            </div>
          </div>
          <button
            onClick={() => kapat(m.id)}
            disabled={kapaniyor}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-green-700 hover:bg-green-600 disabled:opacity-50 text-white text-xs font-bold transition-all shrink-0"
          >
            {kapaniyor ? (
              <Loader className="w-3 h-3 animate-spin" />
            ) : (
              <CheckCircle className="w-3 h-3" />
            )}
            Arızayı Kapat
          </button>
        </div>
      ))}

      {/* Toggle */}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-orange-500/60 text-orange-400 text-xs font-semibold hover:bg-orange-500/10 transition-all"
      >
        <AlertTriangle className="w-3.5 h-3.5" />
        Demo / Arıza Test Paneli
        {aktifTestler.length > 0 && (
          <span className="ml-1 px-1.5 py-0.5 rounded-full bg-red-500 text-white text-xs">
            {aktifTestler.length}
          </span>
        )}
      </button>

      {open && (
        <div className="mt-2 p-4 rounded-xl border border-orange-500/20 bg-orange-950/10">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse" />
              <span className="text-orange-400 text-xs font-bold uppercase tracking-widest">
                Demo / Test Modu
              </span>
            </div>
            <button onClick={() => setOpen(false)}>
              <X className="w-4 h-4 text-slate-500 hover:text-slate-300" />
            </button>
          </div>

          <p className="text-slate-400 text-xs mb-4 leading-relaxed">
            Seçilen makine için kritik arıza tetiklenir. Cron o makine için
            durdurulur, iş emri açılır, bakım planına planlı duruş eklenir.
            Kapatılınca cron devreye girer.
          </p>

          <div className="mb-3">
            <label className="text-slate-400 text-xs block mb-1">
              Makine Seç <span className="text-red-400">*</span>
            </label>
            <select
              value={seciliMakine}
              onChange={(e) => {
                setSeciliMakine(e.target.value);
                setDurum(null);
                setSonuc(null);
              }}
              className="bg-slate-800 border border-slate-600 text-slate-200 text-sm rounded-lg px-3 py-2 w-full focus:outline-none focus:border-orange-500"
            >
              <option value="">-- Makine Seç --</option>
              {MAKINELER.map((m) => (
                <option
                  key={m.id}
                  value={m.id}
                  disabled={aktifTestler.some((t) => t.id === m.id)}
                >
                  {m.ad}
                  {aktifTestler.some((t) => t.id === m.id)
                    ? " (Test Aktif)"
                    : ""}
                </option>
              ))}
            </select>
          </div>

          <button
            onClick={tetikle}
            disabled={!seciliMakine || durum === "loading"}
            className="w-full py-2.5 rounded-lg bg-red-600 hover:bg-red-500 disabled:bg-slate-700 disabled:cursor-not-allowed text-white text-sm font-bold transition-all"
          >
            {durum === "loading" ? (
              <span className="flex items-center justify-center gap-2">
                <Loader className="w-4 h-4 animate-spin" /> Tetikleniyor...
              </span>
            ) : (
              "🔴 Kritik Arıza Tetikle"
            )}
          </button>

          {durum === "success" && sonuc && (
            <div className="mt-3 p-3 rounded-lg bg-slate-800 border border-slate-700 space-y-1.5">
              <p className="text-green-400 text-xs font-bold">
                ✅ {sonuc.machine} — Arıza Tetiklendi
              </p>
              <p className="text-slate-400 text-xs">
                📋 İş Emri:{" "}
                <span className="text-white font-mono">
                  #{sonuc.work_order_id}
                </span>
              </p>
              <p className="text-slate-400 text-xs">
                ⚠️ Olasılık:{" "}
                <span className="text-red-400 font-bold">
                  %{Math.round(sonuc.probability * 100)}
                </span>
              </p>
              <p className="text-slate-400 text-xs">
                📅 Planlı Duruş:{" "}
                <span className="text-yellow-400">{sonuc.durus_tarihi}</span>
              </p>
              <p className="text-slate-500 text-xs mt-1">
                Cron durduruldu. Kapatmak için yukarıdaki banner'ı kullan.
              </p>
            </div>
          )}

          {durum === "error" && (
            <div className="mt-3 p-3 rounded-lg bg-red-950/30 border border-red-500/30">
              <p className="text-red-400 text-xs">❌ {mesaj}</p>
            </div>
          )}

          <div className="mt-3 p-3 rounded-lg bg-slate-800/50 border border-slate-700">
            <p className="text-slate-500 text-xs leading-relaxed">
              <span className="text-slate-400 font-semibold">Akış: </span>
              Tetikle → Kritik sensör DB'ye yazılır → Makine{" "}
              <span className="text-red-400">critical</span> → Cron{" "}
              <span className="text-orange-400">durur</span> → İş emri{" "}
              <span className="text-yellow-400">açılır</span> → Bakım planı
              eklenir → <span className="text-green-400">Kapat</span> → Cron
              devreye girer
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
